module.exports = __webpack_public_path__ + "img/凌烟阁大法帖（黄庭坚体）白.03f3cf86.png";